import lang from '@/lang'

const warehouseCodeMap = new Map([
  ['K', lang.t('CargoMsg.Cargo_Customer')],
  ['M', lang.t('SeaExport.DestinationAgent')],
  ['Z', lang.t('CargoMsg.Cargo_NominatedAgent')]
])

export class WarehouseCodeUtil {
  static getName(code) {
    return warehouseCodeMap.get(code)
  }
}
